import React, {useState} from "react";
import {useFormik} from "formik";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import {StyledInput} from "../components/form/input";
import {StyledButton} from "../components/ui-base/button";
import {AuthService} from "../services/auth.service";
import * as Yup from "yup";
import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import NotAuthWrapper from "../components/not-auth-wrapper";
import NotAuthHeader from "../components/not-auth-header";
import {Colors} from "../theme/colors";
import {StyledH3, StyledP1, StyledP3} from "../components/ui-base/styles";

const ResetPasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
        .required(),
    reNewPassword: Yup.string().required().equals([Yup.ref('newPassword')])
});

const ResetPasswordPage = () => {
    const [passReset, setPassReset] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { t } = useTranslation('common');

    const remindPassword = useFormik({
        initialValues: {
            newPassword: '',
            reNewPassword: ''
        },
        validationSchema: ResetPasswordSchema,
        onSubmit: async values => {
            const res = await AuthService.resetPassword(queryParams.get('user_id'), parseInt(queryParams.get('timestamp')), queryParams.get('signature'), values.newPassword);

            if (res) {
                setPassReset(true);
            }
        }
    });

    return (
        <NotAuthWrapper children={
            <>
                <NotAuthHeader/>

                <Grid item container direction="column" justifyContent="center" alignItems="center" xs>
                    <StyledResetPassContainer>
                        {!passReset &&
                            <>
                                <StyledH3 color={Colors.neutral10}>{t('resetPassword.setNewPass')}</StyledH3>

                                <StyledP1 color={Colors.gray2}>{t('resetPassword.setNewPassDesc')}</StyledP1>

                                <form onSubmit={remindPassword.handleSubmit} style={{width: '100%'}}>
                                    <Grid container spacing={2} direction="column">
                                        <Grid item>
                                            <StyledInput
                                                id="newPassword"
                                                label={t('resetPassword.newPass')}
                                                type={"password"}
                                                onChange={remindPassword.handleChange}
                                                value={remindPassword.values.newPassword}
                                                error={remindPassword.errors.newPassword && remindPassword.touched.newPassword}
                                            />
                                        </Grid>

                                        <Grid item>
                                            <StyledInput
                                                id="reNewPassword"
                                                label={t('resetPassword.reNewPass')}
                                                type={"password"}
                                                onChange={remindPassword.handleChange}
                                                value={remindPassword.values.reNewPassword}
                                                error={remindPassword.errors.reNewPassword && remindPassword.touched.reNewPassword}
                                            />
                                        </Grid>

                                        <Grid item>
                                            <StyledP3 color={Colors.neutral50}>{t('register.passwordInfo')}</StyledP3>
                                        </Grid>

                                        <Grid item container direction="row" justifyContent="center">
                                            <StyledButton type="submit" color={'primary'}>
                                                {t('resetPassword.saveButton')}
                                            </StyledButton>
                                        </Grid>
                                    </Grid>
                                </form>
                            </>
                        }

                        {passReset &&
                            <>
                                <StyledH3 color={Colors.neutral10}>{t('resetPassword.successTitle')}</StyledH3>

                                <Grid item container direction="row" justifyContent="center">
                                    <Link to={'/login'}>
                                        <StyledButton type="submit" color={'primary'}>
                                            {t('resetPassword.successButton')}
                                        </StyledButton>
                                    </Link>
                                </Grid>
                            </>
                        }
                    </StyledResetPassContainer>
                </Grid>


            </>
        }/>
    );
}

const StyledResetPassContainer = styled(Grid)`
  border-radius: 32px;
  border: 1px solid ${Colors.secondary95};
  background: ${Colors.neutral98};
  width: 450px;
  padding: 2rem;
  
  ${StyledP1}, ${StyledH3} {
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;

export default ResetPasswordPage;
